export const name = 'landingPage' as const
